module.exports = "<p>\r\n  statcommandsurplace works!\r\n</p>\r\n"